export const USER_STATE = 'USER_STATE';
export const USER_ACCOUNT_LOCKED = 'USER_ACCOUNT_LOCKED';
export const CLEAR = 'CLEAR';
export const REMOVE_ERROR = 'REMOVE_ERROR';
export const ERRORS = 'ERRORS';
export const NOTIFICATIONS = 'NOTIFICATIONS';
export const UPDATE_FILTER = 'UPDATE_FILTER';
export const CLEAR_FILTER = 'CLEAR_FILTER';
export const CLEAR_PRE_SELECT = 'CLEAR_PRE_SELECT';
export const IS_MOBILE = 'IS_MOBILE';
export const IS_TABLET = 'IS_TABLET';
export const BUSY = 'BUSY';
export const ADD_TODO = 'ADD_TODO';
export const REMOVE_TODO = 'REMOVE_TODO';
export const TODOS = 'TODOS';
export const MAX_UPLOAD_SIZE = 'MAX_UPLOAD_SIZE';
export const NOTIFICATION_BUSY_STATUS = 'NOTIFICATION_BUSY_STATUS';
export const MY_LEADS_RESULT_COUNT = 'MY_LEADS_RESULT_COUNT';
export const BUY_LEADS_RESULT_COUNT = 'BUY_LEADS_RESULT_COUNT';
export const FIRST_BULK_BUY = 'FIRST_BULK_BUY';
export const HIDE_WELCOME_MESSAGE = 'HIDE_WELCOME_MESSAGE';
